import { useUserContext } from '@/components/user-context/user-context-provider';
import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { RovoDevSignupUnavailable } from '../rovo-dev-signup-unavailable';

import { LoggedOutDevAIFree } from './free/logged-out-devai-free';
import { LoggedOutRovoDevStandard } from './standard/logged-out-rovo-dev-standard';

export const LoggedOutDevAI = (): JSX.Element => {
	const { edition } = useUserContext();

	if (checkFeatureFlagGate(featureFlags.killRovoDevSignup)) {
		return <RovoDevSignupUnavailable />;
	}

	if (edition === 'free' && checkFeatureFlagGate(featureFlags.enableRovoDevBetaSignup)) {
		return <LoggedOutDevAIFree />;
	}

	return <LoggedOutRovoDevStandard />;
};
